
const OmniChatApi = (API) => {
  const baseUrl = process.env.VUE_APP_OMNI_API_CHAT_URL
  return {
    async getAtendente (authorization) {
      return API.get(`${baseUrl}/attendants/me`, {
        headers: {
          authorization
        }
      })
    }
  }
}

export default OmniChatApi
